import { lazy, Suspense } from 'react';
import { Spinner } from '@radix-ui/themes';
import Page from 'ui/design-base/Page';

const LoginForm = lazy(() => import('ui/design-base/LoginForm'));

const LoginPage = () => (
  <Page title='Accedi' description='Pagina di accesso a tutte le funzionalità del sito'>
    <div className='flex justify-center'>
      <div className='flex w-full flex-wrap justify-center p-4 md:w-auto'>
        <Suspense fallback={<Spinner />}>
          <LoginForm />
        </Suspense>
      </div>
    </div>
  </Page>
);

export default LoginPage;
